/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Relation_CycleInputs */

const en_relation_cycle = /** @type {(inputs: Relation_CycleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`These items would block each other.`)
};

const de_relation_cycle = /** @type {(inputs: Relation_CycleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Vorgänge würden sich gegenseitig blockieren.`)
};

/**
* | output |
* | --- |
* | "These items would block each other." |
*
* @param {Relation_CycleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const relation_cycle = /** @type {((inputs?: Relation_CycleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Relation_CycleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_relation_cycle(inputs)
	return en_relation_cycle(inputs)
});